module.exports = __webpack_public_path__ + "img/upairy-tabs.d7d5bc35.png";